import {mentor} from "../assets"
const Mentors2023 = [
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image: mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
];
const Mentors2022 = [
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image: mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
];
const Mentors2021 = [
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image: mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
  {
    name: "Ravinder Sharma",
    designation: "Mentor",
    image:  mentor,
    github: "www.github.com",
    linkedln: "www.linkedln.com",
  },
];
export {Mentors2021,Mentors2022,Mentors2023};
